import partition from 'lodash/partition';

import type { HasVisible } from '../../types';

// Split items into two new arrays, the first containing visible items and the second containing hidden items
export const partitionByVisible = <T extends HasVisible>(items: T[]): [T[], T[]] =>
	partition(items, (item) => item.visible);
